// Module
var code = "<li class=\"uia-custom-action\"> <a ng-click=\"model.trackCustomAction()\">{{ name }}</a> </li> ";
// Exports
module.exports = code;